import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

import { getComponentByType } from '@/pages/questions/liste-questions/components/get-component-by-type';
import type { Faq } from '@/types/api/faq';
import { styleStandaloneLinksAsCta } from '@/lib/helpers';

export interface FaqCardProps {
    faq: Faq;
    index?: number;
}

const FaqCard = (props: FaqCardProps) => {
    const { faq } = props;
    const [show, setShow] = useState(false);

    return (
        <div className="border rounded-lg overflow-hidden transition-all duration-200">
            <button
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer hover:bg-muted/50 transition-colors"
                onClick={() => setShow(!show)}
                aria-expanded={show}
            >
                <span
                    className={`text-sm font-medium pr-4 ${show ? 'text-primary' : ''}`}
                    dangerouslySetInnerHTML={{ __html: faq.question }}
                />
                <ChevronDown className={`w-4 h-4 shrink-0 text-muted-foreground transition-transform duration-200 ${show ? 'rotate-180' : ''}`} aria-hidden="true" />
            </button>
            <div className={`overflow-hidden transition-all duration-300 ${show ? 'max-h-[5000px] opacity-100' : 'max-h-0 opacity-0'}`}>
                <div className="px-6 pt-2 pb-6 text-sm text-muted-foreground leading-relaxed space-y-4">
                    <div dangerouslySetInnerHTML={{ __html: styleStandaloneLinksAsCta(faq.content_html) }} />
                    {getComponentByType(faq.type)}
                </div>
            </div>
        </div>
    );
};

export default FaqCard;
